import { $authHost } from '@/http/index'

const NOMENCLATURE = 'nomenclature'

export const getNomenclature = async (name) => {
  const { data } = await $authHost.get(`${NOMENCLATURE}?search[Name]=${name}`)
  return data
}
